/**
 * @generated SignedSource<<2d954cca05767e23d66d98dead2d89a2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionCreateButtonFragment$data = {
  readonly id: string;
  readonly latestCreatedVersion: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly version: Semver;
    }>;
  };
  readonly latestVersion: {
    readonly id: string;
    readonly version: Semver;
  } | null | undefined;
  readonly versionsInput: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly publishedAt: DateTime | null | undefined;
        readonly version: Semver;
      };
    }>;
  };
  readonly " $fragmentType": "DatasetVersionCreateButtonFragment";
};
export type DatasetVersionCreateButtonFragment$key = {
  readonly " $data"?: DatasetVersionCreateButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionCreateButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v2 = [
  (v0/*:: as any*/),
  (v1/*:: as any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "versionsInput"
        ]
      }
    ]
  },
  "name": "DatasetVersionCreateButtonFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "DatasetVersion",
      "kind": "LinkedField",
      "name": "latestVersion",
      "plural": false,
      "selections": (v2/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": "latestCreatedVersion",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "DatasetVersionConnection",
      "kind": "LinkedField",
      "name": "versions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DatasetVersion",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v2/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": "versions(first:1)"
    },
    {
      "alias": "versionsInput",
      "args": null,
      "concreteType": "DatasetVersionConnection",
      "kind": "LinkedField",
      "name": "__DatasetVersionCreateButtonFragment_versionsInput_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DatasetVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DatasetVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "publishedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Dataset",
  "abstractKey": null
};
})();

(node as any).hash = "bf2e3e908b22ef27f356db66a045edfb";

export default node;
